import { Action, RetailKadClientTypes } from '@state/actions/Type';
import { Country } from '@utils/pageConfig/Types';
import { getSessionStorage, StorageKey } from '@utils/StorageUtils';

export interface RetailKadClientState {
  clientId: number;
  countries: Country[];
  clientName?: string;
}

const getInitialState = () => {
  const storeRetailKadClient = JSON.parse(getSessionStorage(StorageKey.RetailKadClient) as string);

  if (storeRetailKadClient !== null) {
    return {
      clientId: storeRetailKadClient.clientId,
      countries: storeRetailKadClient.countries,
    };
  }

  return Object.freeze({
    clientId: -1,
    countries: [{ id: '', name: '', currency: '' }],
  });
};

const RetailKadClientReducer = (state: RetailKadClientState = getInitialState(), action: Action) => {
  if (RetailKadClientTypes.RetailKadClientUpdate === action.type) {
    return {
      ...state,
      clientId: action.payload.clientId,
      countries: action.payload.countries,
    };
  }

  return state;
};

export default RetailKadClientReducer;
